import React from "react";
import { useQuery } from "seed/gql";
import { Loading } from "seed/helpers";
import View from "./Folders.view";


function Sidenav({ user, selectedFolder, isDeveloper, setSelectedFolder }) {

  const reqFolders = useQuery(`{
    folders {
      name
      isHidingFlows
    }
  }`, `user.id=${user.id}`, { orderBy: "name" });

  const onClickLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace("/logout");
  }

  if (reqFolders.loading) return <PlaceholderView />;
  if (reqFolders.error) return "Error";

  const folders = reqFolders?.data?.folders ? 
    [...reqFolders.data.folders].sort((a,b) => (!b.isHidingFlows ? 1 : 0) - (!a.isHidingFlows ? 1 : 0)) : [];

  return (
    <View
      user={user}
      folders={folders}
      selectedFolder={selectedFolder}
      isDeveloper={isDeveloper}
      setSelectedFolder={setSelectedFolder}
      onClickLogout={onClickLogout}
    />
  );
}


const PlaceholderView = () =>
  <div id="start-nav-wrapper" className="d-flex justify-content-center">
    <div id="start-nav" class="card">
      <div class="card-body pt-4 pb-5">
        <Loading size={35} />
      </div>
    </div>
  </div>

export default Sidenav;